import { useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { Referral } from 'src/shared/schemas/referrals/referral'

const getReferralById = (referralId: number) => getRequest<Referral>(`/referrals/?id=${referralId}`)

export const useReferralById = (referralId: number) => {
  return useSuspenseQuery({
    queryKey: queries.referrals.detail(referralId).queryKey,
    queryFn: () => getReferralById(referralId),
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
}
